import React, {PureComponent} from 'react';
import {FormattedNumber, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';

class PriceTag extends PureComponent {

  render() {
    const {intl: {formatMessage}, price} = this.props;

    if (price === undefined) {
      return null;
    }

    if (!isNaN(price)) {
      if (price === 0) {
        return null;
      }
      // eslint-disable-next-line react/style-prop-object
      return (<FormattedNumber value={price} style="currency" currency="EUR"/>);
    }

    if (price.value !== undefined) {
      // eslint-disable-next-line react/style-prop-object
      return (<FormattedNumber value={price.value} style="currency" currency="EUR"/>);
    }

    return (
      <span>
        {formatMessage({id: 'price.from-to'}, {
          min: new Intl.NumberFormat('fr-BE', {style: 'currency', currency: 'EUR'}).format(price.minValue),
          max: new Intl.NumberFormat('fr-BE', {style: 'currency', currency: 'EUR'}).format(price.maxValue),
        })}
      </span>
    );
  }
}

PriceTag.propTypes = {
  price: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.shape({
      minValue: PropTypes.number.isRequired,
      maxValue: PropTypes.number.isRequired
    }),
    PropTypes.shape({
      value: PropTypes.number.isRequired
    }),
  ]).isRequired
};

export default injectIntl(PriceTag);
